function scrollCtrlNative(){

  $('html').addClass('scrolltype-native')


  let timeoutScrollend
  function onScroll() {
    st.eased = st.easedReal = st.current = window.scrollY
    bus.emit('scroll')
    bus.emit('scrollupdate')
    clearTimeout(timeoutScrollend)
    timeoutScrollend = setTimeout(function(){
      bus.emit('scrollend')
    }, 200)
  }

  bus.emit('scrollupdate')


  function eventOn(){
    $(window).on('scroll', onScroll)
    bus.on('pageLeaveEnd', eventOff)
  }
  function eventOff(){
    $(window).off('scroll', onScroll)
    bus.off('pageLeaveEnd', eventOff)
  }
  eventOn()

}
export default scrollCtrlNative